import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, FileUpload, Select, Checkbox, RadioList, CKEditor} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ButtonToolbar from '../../components/ButtonToolbar';
import ChangeBar from '../../components/ChangeBar';
import NavBar from '../../components/NavBar';
import {TabGroup, Tab} from 'reactis-tabs';
import TableForm from "../../components/TableForm";
import UserLookup from "../../components/Form/UserLookup";
import EmailaccountLookup from "../../components/Form/EmailaccountLookup";
import EmaillayoutLookup from "../../components/Form/EmaillayoutLookup";

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);
		this.state = {
			selectedTab: 0
		};

		this.api = {
			fetch: 'emailtemplate.fetch',
			save: 'emailtemplate.save',
		};

		this.changeEvent = 'emailtemplate.change';
		this.savePushState = '/emailtemplate';

		this.messages = {
			notfound: 'E-mailová šablona nenalezena!',
			saved: 'E-mailová šablona byla uložena.',
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Název je povinná položka!'}
				}
			},
			users: {
				class: UserLookup,
				multiple: true,
				label: 'Odběratelé'
			},
			emailaccount: {
				class: EmailaccountLookup,
				clearable: false,
				label: 'Odesílatel'
			},
			emaillayout: {
				class: EmaillayoutLookup,
				label: 'Layout'
			},
			to: {
				class: TextInput,
				label: 'Komu (e-mail)'
			},
			cc: {
				class: TextInput,
				label: 'Kopie (e-mail)'
			},
			bcc: {
				class: TextInput,
				label: 'Skrytá kopie (e-mail)'
			},
			subject: {
				class: TextInput,
				label: 'Předmět e-mailu',
				rules: {
					presence: {message: 'Zadejte předmět e-mailu!'}
				}
			},
			images_inline: {
				class: RadioList,
				label: 'Obrázky',
				options: [{id: 1, title: 'přiložené do e-mailu'}, {id: 0, title: 'externí'}]
			},
			text: {
				class: CKEditor,
				label: 'Text',
				toolbar: null,
				height: 300
			},
			files: {
				class: FileUpload,
				label: 'Přílohy'
			},
			imessage_subject: {
				class: TextInput,
				label: 'Předmět'
			},
			imessage_text: {
				class: TextArea,
				label: 'Text',
				style: {height: 100}
			},
			push_subject: {
				class: TextInput,
				label: 'Předmět'
			},
			push_text: {
				class: TextArea,
				label: 'Text',
				style: {height: 100}
			},
			sms: {
				class: TextArea,
				label: 'Text',
				style: {height: 100}
			},
			call_type: {
				class: RadioList,
				options: [{id: 1, title: 'Audio soubor'}, {id: 2, title: 'Text-To-Speech'}],
				label: 'Mód'
			},
			call_audio_file: {
				class: FileUpload,
				multiSelection: false,
				label: 'Audio soubor'
			},
			call_text_lang: {
				class: Select,
				options: [{id: 'en', title: 'Angličtina'}],
				value: 'en',
				label: 'Jazyk'
			},
			call_text: {
				class: TextArea,
				label: 'Text',
				style: {height: 80}
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				visible: canEdit,
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				visible: canEdit,
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			}
		];
		const data = this.form.getValues().toJS();

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<NavBar buttons={toolbar} onClose={this.props.closeTab} title="Notifikační šablona" />
					<Toolbar title="Notifikační šablona">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<ChangeBar visible={this.state.showChangedBar} items={this.state.extChangedItems} onAcceptChanges={() => this.acceptChanges()} onClose={() => this.setState({showChangedBar: false})} />
					<div className="row">
						<div className="col-md-10">
							<table className="form">
								<tbody>
									<FormRow name="title" labelWidth="145"/>
									<FormRow name="users" labelHelp="Není potřeba vyplňovat pokud se notifikace týka relevantního uživatele, kterému je zpráva určena logikou aplikace." />
								</tbody>
							</table>
							<br/>
							{this.state.selectedTab == 0 &&
							<TableForm>
								<FormRow name="emailaccount" labelWidth="145" />
								<FormRow name="to" />
								<FormRow name="cc" />
								<FormRow name="bcc" />
								<FormRow name="subject" />
								<FormRow name="emaillayout" />
								<FormRow name="text" />
								<FormRow name="files" />
								<FormRow name="images_inline" />
							</TableForm>}
							{this.state.selectedTab == 1 &&
							<TableForm>
								<FormRow name="imessage_subject" labelWidth="145" />
								<FormRow name="imessage_text" />
							</TableForm>}
							{this.state.selectedTab == 2 &&
							<TableForm>
								<FormRow name="push_subject" labelWidth="145" />
								<FormRow name="push_text" />
							</TableForm>}
							{this.state.selectedTab == 3 &&
							<TableForm>
								<FormRow name="sms" labelWidth="145" />
							</TableForm>}
							{this.state.selectedTab == 4 &&
							<TableForm>
								<FormRow name="call_type" labelWidth="145" />
								<FormRow name="call_audio_file" visible={data.call_type == 1} />
								<FormRow name="call_text_lang" visible={data.call_type == 2} />
								<FormRow name="call_text" visible={data.call_type == 2} />
							</TableForm>}

							<br/>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/EmailTemplate/Form.js